require('./bootstrap');
require('slick-carousel');
require('magnific-popup');

import tippy from 'tippy.js';

tippy('[data-tippy-content]',{
    theme: 'light',

});

function hideBody() {
    $('html, body').css('overflow', 'hidden');
}

function clearBodyStyle() {
    $('html, body').removeAttr('style');
}

$(document).ready(function () {


    $(document).on('click','.offer__link', function () {
        hideBody();

        let id = $(this).attr('data-modal');

        $('.modal').addClass('modal--hide');
        $('.modal').filter('[data-open=' + id + ']').removeClass('modal--hide');
    });

    $(document).on('click','.modal__close', function () {
        clearBodyStyle();
       $(this).parents('.modal').addClass('modal--hide');
    });

    // Появление меню
    $(window).scroll(function() {
        if ($(this).scrollTop() > 115) {
            $('.fix-menu').fadeIn();
        } else {
            $('.fix-menu').fadeOut();
        }
    });


    // Плавный скролл по якорям
    $(".menu__item-link").click(function() {

        let id = $(this).attr('data-link');

        $('body').addClass('waypoint-hide');

        $('.menu__item-link').removeClass('menu__item-link--active');
        $('.menu__item-link').filter('[data-link=' + id + ']').addClass('menu__item-link--active');

        $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 100
        }, {
            duration: 500,
            easing: "swing",
            complete: function () {
                $('body').removeClass('waypoint-hide');
            }
        });

        return false;
    });

    // Карусель для спецпредложений
    $('.offer-list').slick({
        infinite: false,
        slidesToScroll: 1,
        variableWidth: true,
        arrows: true,
        prevArrow: $('.icon__left'),
        nextArrow: $('.icon__right'),
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 745,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    variableWidth: true,
                    infinite: true,
                }
            }

        ]
    });

});